// =====================================
//  選擇常用地址 modal
//
//  @author: Gray
//  @time 2016 / 09 / 01
// =====================================

window.InifECMobileApp.directive('selectAddress', ['$rootScope', '$ngModal', '$timeout', 'UserService',
    function ($rootScope, $ngModal, $timeout, UserService) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            // --------------------------------
            // [private] 取得會員的常用地址列表
            // --------------------------------
            var qyFavoriteAddress = function() {

                $scope.isLoading = true;
                $scope.addressList.length = 0;

                UserService.qyFavoriteAddress().then(function(result) {

                    if(Array.isArray(result) && result.length > 0){
                        $scope.addressList = result;
                        $scope.isEmpty = false;
                    } else if($scope.addressList.length == 0) {
                        $scope.isEmpty = true;
                    }

                    $scope.isLoading = false;

                }, function(error) {

                    $scope.isError = true;
                    $scope.isLoading = false;
                })
            }

            // --------------------------------
            // 選擇地址
            // --------------------------------
            var selectAddress = function(address) {

                ($scope.callback) && $scope.callback(address);
                closeModal();
            }

            // -------------------------------
            // 離開選擇常用地址
            // -------------------------------
            var cancel = function() {

                closeModal();
            }

            // -------------------------------
            //  開啟 modal
            // -------------------------------
            var openModal = function() {

                $ngModal.openModal('select-address-modal');
            }

            // -------------------------------
            //  關閉 modal
            // -------------------------------
            var closeModal = function() {

                $ngModal.closeModal('select-address-modal');
            }

            /*==========================
                Events
            ==========================*/            
            $scope.$on('OPEN_SELECT_ADDRESS_MODAL', function(event, data) {
                
                if(data) {
                    $scope.callback = data.callback;

                    qyFavoriteAddress();
                    openModal();
                }
            });

            /*==========================
                Members
            ==========================*/
            $scope.isLoading = false;
            $scope.isEmpty = false;
            $scope.isError = false;

            $scope.addressList = [];

            /*==========================
                Methods
            ==========================*/
            $scope.callback = undefined;
            $scope.selectAddress = selectAddress; // 選擇地址
            $scope.cancel = cancel; // 離開選擇常用地址

            /*==========================
                init
            ==========================*/

        }]

        _dir.restrict = "E";
        _dir.scope = true;
        _dir.templateUrl = "mobile/partials/modal/select_address.html";
        _dir.controller = controller;

        return _dir;
    }]
);